import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { VideoListItem } from "api/models/Videos/videoList";
import MenuItem from "@mui/material/MenuItem";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import {
  getActiveChannelUuidSelector,
  getKebabOptionsSelector,
} from "store/reducers/ChannelDetails/channelList";
import { updateVideoStatus } from "store/async-actions/Videos/videosActions";
import { useLocation, useNavigate } from "react-router-dom";
import {
  currentVideoSelector,
  setCurrentVideo,
} from "store/reducers/Videos/videoList";
import { setVideoFile } from "store/reducers/Videos/videos";
import { toastInfo } from "hooks/useToastify";
import { getHiveSelector } from "store/reducers/HiveDetails/hiveDetails";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "1px solid #f0f0f0",
  borderRadius: 3,
  padding: 2,
  boxShadow: 24,
};

const ITEM_HEIGHT = 48;

interface Props {
  currentVideo: VideoListItem;
}

const VideoKebab = ({ currentVideo }: Props) => {
  const options = useAppSelector(getKebabOptionsSelector);
  const channelUuid = useAppSelector(getActiveChannelUuidSelector);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const hiveDetails = useAppSelector(getHiveSelector);

  const handleCopy = (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        if (!!text) {
          toastInfo("Copied link to clipboard");
        } else {
          toastInfo(
            "This video isnt available at the moment, please try another one"
          );
        }
      })
      .catch((error) => {
        console.error("Error copying text: ", error);
      });
  };

  const location = useLocation();

  const handleClose = (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    dispatch(setCurrentVideo(currentVideo));
    //   e.currentTarget.innerText === "Edit" && handleEditOpen();
    e.currentTarget.innerText === "Approve" &&
      dispatch(
        updateVideoStatus({
          videoId: currentVideo.videoUuid,
          channelUUID: channelUuid!,
          status: "Ready",
          approvalNotes: "Approval of video",
          communityId: hiveDetails?.communityId || 0,
        })
      );
    e.currentTarget.innerText === "Archive" &&
      dispatch(
        updateVideoStatus({
          videoId: currentVideo.videoUuid,
          channelUUID: channelUuid!,
          status: "ARCHIVED",
          approvalNotes: "Archive video",
          communityId: hiveDetails?.communityId || 0,
        })
      );
    e.currentTarget.innerText === "Pending" &&
      dispatch(
        updateVideoStatus({
          videoId: currentVideo.videoUuid,
          channelUUID: channelUuid!,
          status: "PENDING",
          approvalNotes: "move video to pending",
          communityId: hiveDetails?.communityId || 0,
        })
      );
    e.currentTarget.innerText === "Reject" &&
      dispatch(
        updateVideoStatus({
          videoId: currentVideo.videoUuid,
          channelUUID: channelUuid!,
          status: "Rejected",
          approvalNotes: "Rejection of video",
          communityId: hiveDetails?.communityId || 0,
        })
      );
    e.currentTarget.innerText === "Share" &&
      handleCopy(`${document.location.href}/videos/${currentVideo.videoUuid}`);
    if (e.currentTarget.innerText === "Edit") {
      navigate(`videos/${currentVideo.videoUuid}/edit`);
      dispatch(setVideoFile(null));
    }
    //   e.currentTarget.innerText === "Delete" && handleReasonsOpen();
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon htmlColor="#ffffff" />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 3,
            width: "12ch",
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option} onClick={(e) => handleClose(e)}>
            <p className="text-sm">{option}</p>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default VideoKebab;
